import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DxcBadgeVariant, resolveDxcVariant } from '../dxc.types';

/**
 * Píldora de estado. Resuelve la variante desde el mapa único de `dxc.types`
 * para que ninguna vista invente su propio verde — §5 de la regla.
 */
@Component({
    standalone: true,
    selector: 'dxc-status-badge',
    template: `
        <span [class]="badgeClass">{{ label }}</span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DxcStatusBadgeComponent {

    /** Clave del dominio. Se busca en DXC_STATUS_VARIANT. */
    @Input() status = '';
    /** Texto a mostrar. Si se omite se usa `status`. */
    @Input() text = '';
    /** Fuerza la variante cuando el estado no está en el mapa. */
    @Input() variant?: DxcBadgeVariant;
    /**
     * Suelta el relleno y el borde, y conserva la señal: el color de la
     * variante. Es para una fila de listado, donde la clasificación ya ocupa la
     * única pastilla llena que la fila puede permitirse.
     */
    @Input() quiet = false;
    /**
     * Presencia: filete y halo del tono de la variante. `full` es para el
     * estado que encabeza una pantalla —uno por región—; `soft`, para el de una
     * fila de listado, donde hay uno por registro.
     */
    @Input() glow?: 'soft' | 'full';

    get resolvedVariant(): DxcBadgeVariant { return resolveDxcVariant(this.status, this.variant); }

    get badgeClass(): string {
        return `dxc-badge dxc-badge--${this.resolvedVariant}`
            + (this.quiet ? ' dxc-badge--quiet' : '')
            + (this.glow === 'full' ? ' dxc-badge--glow' : this.glow === 'soft' ? ' dxc-badge--glow-soft' : '');
    }

    get label() { return this.text || this.status; }
}
